import { render, staticRenderFns } from "./subAgendaPC.vue?vue&type=template&id=5a219fbb&scoped=true"
import script from "./subAgendaPC.vue?vue&type=script&lang=js"
export * from "./subAgendaPC.vue?vue&type=script&lang=js"
import style0 from "./subAgendaPC.vue?vue&type=style&index=0&id=5a219fbb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a219fbb",
  null
  
)

export default component.exports